import { jsx as _jsx } from "react/jsx-runtime";
import { useSelector, useDispatch } from 'react-redux';
import { useAemConfig } from '@as-react/common-components';
import { SizeGuideV2 } from '../components/product-detail/size-guide-v2/SizeGuideV2';
import { makeGetSizeGuideData } from '../redux/product/selectors/ProductSelector';
import { analyticsActions } from '../redux/analytics/actions/AnalyticsActions.creators';
import { productActions } from '../redux/product/actions/ProductActions';
export const SizeGuideContainerV2 = () => {
    const { sizeGuideContent, sizeGuideContentUrl } = useSelector(makeGetSizeGuideData());
    const dispatch = useDispatch();
    const { pdpTemplateName } = useAemConfig();
    const onSizeGuideClick = () => {
        dispatch(productActions.sizeGuideOpen());
        dispatch(analyticsActions.productDetailSizeGuideClick(pdpTemplateName));
    };
    return !sizeGuideContent && !sizeGuideContentUrl ? null : (_jsx(SizeGuideV2, { isPopup: Boolean(sizeGuideContent), sizeGuideContent: sizeGuideContent, sizeGuideContentUrl: sizeGuideContentUrl, onClick: onSizeGuideClick }));
};
